import { createStore } from 'vuex';
import { appMixin } from '../mixin/appMixin';

const store = createStore({
  	state: {
        user: null,
    	systemSettings: {
            hm_working_hours_start: '07:00',
            hm_working_hours_end: '17:00',
            hm_working_days: '1-6',
            currency: {
                code: 'GBP',
                symbol: '£',
                label: 'Pound'
            },
        },
	},
	mutations: {
		setSystemSettings(state, payload) {
			state.systemSettings = payload;
		},
        setUser(state, payload) {
            state.user = payload;
        },
	},
    getters: {
    	getSystemSettings: state => state.systemSettings,
        getUser: state => state.user,
  	},
	actions: {
		async fetchSystemSettings({ commit }) {
			try {
                const response = await appMixin.methods.getSettings();
                if(response.status === 'success') {
                    commit('setSystemSettings', response.settings);
                }
			} catch (error) {
				console.error('Error fetching system settings:', error);
			}
		},
        async fetchUserProfile({ commit }) {
            try {
                const response = await appMixin.methods.getUserProfile();
                if(response && response.status === 'success') {
                    commit('setUser', response.user);

                    // Call actions to fetch system settings and available schedules
                    store.dispatch('fetchSystemSettings');
                }
            } catch (error) {
                console.error('Error fetching user profile:', error);
            }
        }
	}
});

// Request the data from the server

store.dispatch('fetchUserProfile');

export default store;
